<template>
  <v-dialog width="600" v-model="isUpdating" persistent>
    <v-card class="rounded-lg">
      <v-card-text>
        <v-row class="text-center">
          <v-col>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col>
            <h3>{{ $t("entities.image_uploading") }}</h3>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-container class="pa-6">
    <v-row>
      <v-col cols="12" md="7">
        <v-row no-gutters>
          <v-col>
            <h2>{{ $t("support.headline") }}</h2>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="mb-4 mt-4">
            <v-alert
              v-model="alert"
              closable
              :type="alertType"
              class="rounded-lg"
            >
              {{ this.alertText }}
            </v-alert>
          </v-col>
        </v-row>
        <v-form v-model="valid" ref="form">
          <v-row no-gutters>
            <v-col>
              <v-select
                :items="items"
                item-text="text"
                item-value="value"
                v-model="type"
                :label="$t('support.message_type_input')"
                :rules="[required_rule]"
                variant="underlined"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-text-field
                type="email"
                v-model="email"
                :label="$t('support.email_input')"
                :rules="[email_rules]"
                variant="underlined"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-textarea
                class="mb-4"
                :label="$t('support.description_input')"
                auto-grow
                :rules="[required_rule]"
                v-model="description"
                variant="underlined"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <file-manager
                    ref="imagesManager"
                    @update:files="handleFiles"
                    :files="this.files"
                    preview="gallery"
                    :multiple="true"
                    :upload-url="`helpdesk/images/${reportId}`"
                    upload-attribute="files"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="align-center pb-4">
            <v-col cols="auto" class="px-0">
              <v-checkbox color="light-green-darken-2" id="check" v-model="urgent" hide-details></v-checkbox>
            </v-col>
            <v-col>
              <label style="font-size: 1.1em" for="check" class="mb-0">{{
                $t("support.urgent_checkbox")
              }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <SaveButton
                :is-saving="isUpdating"
                :label="$t('entities.send')"
                :save="saveChanges"
                :disabled="type === 'question' && email === '' ? true : !valid"
                style="width: 100% !important;"
              >
              </SaveButton>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapActions} from "vuex";
import SaveButton from "@/components/buttons/SaveButton.vue";
import FileManager from "@/components/files/FileManager.vue";
import {nextTick} from "vue";

export default {
  name: "Helpdesk",

  data() {
    return {
      valid: false,
      required_rule: (value) => !!value || this.$t("entities.required"),
      email_rules: (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("support.email_input_invalid"),
      items: [
        {title: this.$t("support.have_question") , value: "question"},
        {title: this.$t("support.have_idea"), value: "idea"},
        {title: this.$t("support.have_problem"), value: "problem"},
      ],
      type: null,
      email: "",
      description: "",
      urgent: false,
      isUpdating: false,
      carouselActiveImage: 0,
      imagesUploading: false,
      alert: false,
      alertType: "success",
      alertText: this.$t('entities.successfull_request'),
      reportId: null,
      files: [],
    };
  },

  components: {
    FileManager,
    SaveButton,
  },

  methods: {
    ...mapActions("Helpdesk", ["createReport"]),

    errorMessage() {
      this.alertText = "Obrázek musí být ve formátu .jpg,.jpeg,.png";
      this.alertType = "error";
      this.alert = true;
      window.scrollTo(0, 0);
    },

    finishSaving() {
      this.imagesUploading = false;
      this.hasRecentlyUpdated = true;
      this.isUpdating = false;
      setTimeout(() => (this.hasRecentlyUpdated = false), 2000);
    },

    handleFiles(files) {
      this.files = files;
    },

    async saveChanges() {
      if (this.$refs.form.validate()) {
        this.isUpdating = true;
        this.reportId = await this.createReport({
          description: this.description,
          email: this.email,
          type: this.type,
          urgent: this.urgent,
        });
        this.imagesUploading = true;
        await nextTick() // wait to update DOM so that file manager has already the new report id in its props
        await this.$refs.imagesManager.upload()
        this.finishSaving();
        this.$refs.form.reset();
        this.email = "";
        this.description = "";
        this.type = "";
        this.urgent = false;
        this.files = [];
        this.alertText = this.$t('entities.successfull_request');
        this.alertType = "success";
        this.alert = true;
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>
<style scoped></style>
